import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { authService } from '../../services/authService';
import { getAdminAuthToken } from '../../config/api.config';

export default function ProtectedRoute() {
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    const token = getAdminAuthToken();
    if (!token) {
      setIsAuthenticated(false);
      return;
    }
    authService.verifySession().then(setIsAuthenticated);
  }, []);

  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen bg-[#f6f7fb] flex flex-col items-center justify-center gap-3">
        <Loader2 size={28} className="animate-spin text-indigo-600" />
        <p className="text-xs font-semibold text-slate-500">Vérification de la session...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
